var map = {
	"./config-production.json": 3122,
	"./config-staging.json": 3123,
	"./config-test.json": 3124
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3121;


//////////////////
// WEBPACK FOOTER
// ./config ^\.\/config\-.*\.json$
// module id = 3121
// module chunks = 1